import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

// Atalho pro AuthContext (usuário, login/logout, estado de sessão).
// Lança se usado fora do AuthProvider — ajuda a pegar erro de composição cedo.
export default function useAuth() {
  const contexto = useContext(AuthContext);
  if (!contexto) {
    throw new Error('useAuth precisa estar dentro de um AuthProvider.');
  }
  return contexto;
}
